module.exports = __webpack_public_path__ + "img/icon_company.45c8e1a7.png";